import {
  useEffect, useCallback, useState, useRef, useMemo,
} from 'react';
import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useHistory } from 'react-router';

import firmwareAction from '@state/firmware/actions';
import devicesApi from '@api/devicesApi';
import getColumns from './columnFirmwares';

function useFirmwares() {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const abortController = useRef(null);
  // const timeoutRef = useRef();
  const timerLopping = useRef();
  const initPagination = useRef({ current: 1, pageSize: 20 });
  const history = useHistory();
  // const [search, setSearch] = useState('');
  const [valueFilter, setValueFilter] = useState('');
  const [loading, setLoading] = useState(false);
  const [firmwares, setFirmwares] = useState([]);
  const [pag, setPagination] = useState(initPagination.current);

  const [isCreate, setIsCreate] = useState(false);
  const currentUser = useSelector(({ user }) => user);

  const abortLastRequest = useCallback(() => {

    if (abortController.current) {

      abortController.current.abort();
      abortController.current = null;

    }

  }, []);

  // const onChangeSearch = useCallback( // input that Filters the data
  //   ({ target: { value } }) => {

  //     if (timeoutRef.current) clearTimeout(timeoutRef.current);
  //     setLoading(false);
  //     timeoutRef.current = setTimeout(() => setSearch(value), 800);

  //   },
  //   // eslint-disable-next-line
  //   []
  // );

  const handleTableChange = useCallback( // load device data
    (pagination, filter, sorter) => {

      abortController.current = new AbortController();
      const { signal } = abortController.current;

      setLoading(true);
      if (timerLopping.current) clearTimeout(timerLopping.current);

      devicesApi
        .getAllFirmwares({
          signal,
        })
        .then((response) => {

          const resp = {
            count: response.lenght,
            results: response,
          };
          // eslint-disable-next-line no-shadow
          const { results: firmwares, count: total } = resp;
          setPagination({ ...pagination, total });
          setLoading(false);
          setFirmwares(firmwares);

          timerLopping.current = setTimeout(
            () => handleTableChange({ pagination, filter, sorter }),
            120000,
          );

        })
        .catch((resError) => {

          if (signal.aborted) return;
          const { fem } = resError;
          // eslint-disable-next-line no-console
          console.log(t(fem));
          setLoading(false);

        });

    },
    [t],
  );

  useEffect( // mount component
    () => {

      handleTableChange(initPagination.current);
      return abortLastRequest;

    },
    // eslint-disable-next-line
      []
  );

  const createFirmware = useCallback( // Go to create /crear-dispositivo
    () => {

      dispatch(firmwareAction.setFirmwaresIdEdit(null));
      history.push('/dispositivos/firmware/crear-firmware');

    },
    [history, dispatch],
  );

  const deleteFirmware = useCallback((e) => { // Delete device by Id

    abortController.current = new AbortController();
    const { signal } = abortController.current;
    const { id } = e;
    devicesApi.deleteFirmwareById({ signal, id })
      .then((response) => {

        handleTableChange(initPagination.current);
        message.success(t('common.successfully_remove'));

      })
      .catch((error) => {

        message.error(t('common.failed_remove'));

      });

  }, [handleTableChange, t]);

  const editDevice = useCallback((e) => { // edit device, save data device in redux

    const defaultData = {
      segment: e.segment,
      version: e.version,
      busines_id: e.business_type_id,
    };
    dispatch(firmwareAction.setFirmwaresIdEdit(e.id));
    dispatch(firmwareAction.setCreateEditFirmwares(defaultData));
    history.push('/dispositivos/firmware/editar-firmware');

  }, [dispatch, history]);

  const columns = useMemo(
    () => getColumns(
      t,
      deleteFirmware,
      currentUser,
      editDevice,
    ), [
      t,
      deleteFirmware,
      currentUser,
      editDevice,
    ],
  );

  const arrayFilter = firmwares.filter((data) => ( // Filter by client
    data.fw_url.toUpperCase().includes(valueFilter.toUpperCase())
  ));

  const getPermissonCreate = useCallback(() => {

    const currentUserRole = currentUser.role;
      // eslint-disable-next-line
      setIsCreate(!!(currentUserRole === 'Superadmin' || currentUserRole === 'Admin'));

  }, []);

  useEffect(() => {

    getPermissonCreate();

}, []);

  return {
    setValueFilter,
    handleTableChange,
    loading,
    arrayFilter,
    firmwares,
    columns,
    // onChangeSearch,
    pagination: pag,
    createFirmware,
    isCreate,
  };

}

export default useFirmwares;
